import { RouteConfig } from 'vue-router';

import QuizOverview from '@/web/views/admin/quizzes/QuizOverview.vue';
import QuizSettings from '@/web/views/admin/quizzes/QuizSettings.vue';
import QuizContent from '@/web/views/admin/quizzes/QuizContent.vue';
import QuizSubmissions from '@/web/views/admin/quizzes/QuizSubmissions.vue';
import QuizSubmissionViewer from '@/web/views/admin/quizzes/QuizSubmissionViewer.vue';

const quizRoutes: Array<RouteConfig> = [
  {
    name: 'quiz-overview',
    path: '',
    component: QuizOverview,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
    },
  },
  {
    name: 'quiz-settings',
    path: 'settings',
    component: QuizSettings,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
    },
  },
  {
    name: 'quiz-content',
    path: 'content',
    component: QuizContent,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
    },
  },
  {
    name: 'quiz-submissions',
    path: 'submissions',
    component: QuizSubmissions,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
    },
  },
];
export default quizRoutes;
